import React from 'react'
import TabbedPanel from '../../components/UI/TabbedPanel//TabbedPanel'
import './MainContent.css'
import Alert from '../../components/UI/Alert/Alert'
import FetchData from '../../shared/fetchData'
import moment from 'moment-jalaali'
import Button from '../../components/UI/Button/Button'
import DatePicker from '../../components/UI/DatePicker/DatePicker'
import CirclePercentage from '../../components/UI/CirclePercentage/CirclePercentage'
import { Redirect } from 'react-router-dom'
import Spinner from '../../components/UI/Spinner/Spinner'

        const MainContent = (props) => {

    const [showType, setShowType] = React.useState('TODAY')
    const [hasError, setHasError] = React.useState(false)
    const [errorContent, setErrorContent] = React.useState('')
    const [fromDate, setFromDate] = React.useState('')
    const [toDate, setToDate] = React.useState('')
    const [fromDateSearch, setFromDateSearch] = React.useState('')
    const [toDateSearch, setToDateSearch] = React.useState('')
    const [totalCount, setTotalCount] = React.useState('')
    const [ongoingCount, setOngoingCount] = React.useState('')
    const [finishedCount, setFinishedCount] = React.useState('')
    const [showCustomDates, setShowCustomDates] = React.useState(false)
    const [goToOrder, setGoToOrder] = React.useState(false)
    const [orderFilter, setOrderFilter] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        const today = new Date()
        var raw = JSON.stringify({"fromDate": moment(today).format('jYYYY/jMM/jDD'), "toDate": moment(today).format('jYYYY/jMM/jDD'), "version": "mtpx001"})
        var url = 'management/api/v1/orders/dashboard'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setFromDate(moment(today).format('jYYYY/jMM/jDD'))
                    setToDate(moment(today).format('jYYYY/jMM/jDD'))
                    setFromDateSearch(moment(today).format('jYYYY/jMM/jDD'))
                    setToDateSearch(moment(today).format('jYYYY/jMM/jDD'))
                    if (result.status == 0) {
                        setTotalCount(result.totalCount)
                        setOngoingCount(result.ongoingCount)
                        setFinishedCount(result.finishedCount)
                    }
                })
                .catch(error => console.log(error))
    }, [])


    const showError = (content) => {
        setHasError(true)
        setErrorContent(content)
        setTimeout(() => {
            setHasError(false)
            setErrorContent('')
        }, 3000)
    }



    const setToday = (event) => {
        const today = new Date()
        let from = moment(today).format('jYYYY/jMM/jDD')
        let to = moment(today).format('jYYYY/jMM/jDD')
        setFromDate(from)
        setToDate(to)
        setFromDateSearch(from)
        setToDateSearch(to)
        setShowCustomDates(false)
        setShowType('TODAY')

        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({"version": "mtpx001", "fromDate": from, "toDate": to})
        var url = 'management/api/v1/orders/dashboard'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == 0) {
                        setTotalCount(result.totalCount)
                        setOngoingCount(result.ongoingCount)
                        setFinishedCount(result.finishedCount)
                    }
                })
                .catch(error => console.log(error))
    }
    const setYesterday = (event) => {
        const today = new Date()
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
        let from = (yesterday).toLocaleDateString('zh-Hans-CN')
        let to = (today).toLocaleDateString('zh-Hans-CN')
        from = moment(from).format('jYYYY/jMM/jDD')
        to = moment(to).format('jYYYY/jMM/jDD')
        setFromDate(from)
        setToDate(to)
        setFromDateSearch(from)
        setToDateSearch(to)
        setShowCustomDates(false)
        setShowType('YESTERDAY')

        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({"version": "mtpx001", "fromDate": from, "toDate": to})
        var url = 'management/api/v1/orders/dashboard'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == 0) {
                        setTotalCount(result.totalCount)
                        setOngoingCount(result.ongoingCount)
                        setFinishedCount(result.finishedCount)
                    }
                })
                .catch(error => console.log(error))
    }
    const setLastWeek = (event) => {
        const today = new Date()
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 7)
        let from = (yesterday).toLocaleDateString('zh-Hans-CN')
        let to = (new Date()).toLocaleDateString('zh-Hans-CN')

        from = moment(from).format('jYYYY/jMM/jDD')
        to = moment(to).format('jYYYY/jMM/jDD')
        setFromDate(from)
        setToDate(to)
        setFromDateSearch(from)
        setToDateSearch(to)
        setShowCustomDates(false)
        setShowType('LASTWEEK')

        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({"version": "mtpx001", "fromDate": from, "toDate": to})
        var url = 'management/api/v1/orders/dashboard'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == 0) {
                        setTotalCount(result.totalCount)
                        setOngoingCount(result.ongoingCount)
                        setFinishedCount(result.finishedCount)
                    }
                })
                .catch(error => console.log(error))
    }

    const setCustomDate = (event) => {
        setFromDate('')
        setToDate('')
        setShowCustomDates(true)
        setShowType('CUSTOMDATE')
    }

    const changeFromDate = (unix, formatted) => {
        let gDate = ''
        gDate = formatted
        setFromDate(gDate)
        setFromDateSearch(gDate)
        if (gDate != '' && toDate != '') {

            const token = window.localStorage.getItem("token")
            var raw = JSON.stringify({"version": "mtpx001", "fromDate": gDate, "toDate": toDate})
            var url = 'management/api/v1/orders/dashboard'
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        if (result.status == 0) {
                            setTotalCount(result.totalCount)
                            setOngoingCount(result.ongoingCount)
                            setFinishedCount(result.finishedCount)
                        }
                    })
                    .catch(error => console.log(error))
        }
    }
    const changeToDate = (unix, formatted) => {
        let gDate = ''
        gDate = formatted
        setToDate(gDate)
        setToDateSearch(gDate)
        if (gDate !== '' && fromDate !== '') {
            const token = window.localStorage.getItem("token")
            var raw = JSON.stringify({"version": "mtpx001", "fromDate": fromDate, "toDate": gDate})
            var url = 'management/api/v1/orders/dashboard'
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        if (result.status == 0) {
                            setTotalCount(result.totalCount)
                            setOngoingCount(result.ongoingCount)
                            setFinishedCount(result.finishedCount)
                        }
                    })
                    .catch(error => console.log(error))
        }
    }

    const getFromOfficeOrders = (event) => {
        setGoToOrder(true)
        setOrderFilter('ONGOING')
    }

    const getToOfficeOrders = (event) => {
        setGoToOrder(true)
        setOrderFilter('FINISHED')
    }

    const customDateClass = showCustomDates ? "MainFadeIn" : "MainFadeOut"

    let path = ''
    if (orderFilter == 'ONGOING') {
        path = 'orders?state=R' + '&from=' + fromDateSearch + '&to=' + toDateSearch
    } else if (orderFilter == 'FINISHED') {
        path = 'orders?state=F' + '&from=' + fromDateSearch + '&to=' + toDateSearch
    }


    const order = goToOrder == true ? <Redirect to={path} /> : ''
    let spinner = loading ? <Spinner /> : ''

    return (
            <div>
                {spinner}
                {order}
                <div className="row text-right small-main-cntnr">
                    <div className="col-1"></div>
                    <div className="col-6 small-main-dates">
                        <div className="row w-100 pr-4">
                            <div className="col-3 small-main-dates-col">
                                <Button btnType={showType == 'TODAY' ? "MainSelect" : "Main"} className="MainBtn" clicked={setToday} >امروز</Button>
                            </div>
                            <div className="col-3 small-main-dates-col">
                                <Button btnType={showType == 'YESTERDAY' ? "MainSelect" : "Main"} className="MainBtn" clicked={setYesterday} >دیروز</Button>
                            </div>
                            <div className="col-3 small-main-dates-col">
                                <Button btnType={showType == 'LASTWEEK' ? "MainSelect" : "Main"} className="MainBtn" clicked={setLastWeek} >هفته اخیر</Button>
                            </div>
                            <div className="col-3 small-main-dates-col">
                                <Button btnType={showType == 'CUSTOMDATE' ? "MainSelect" : "Main"} className="MainBtn" clicked={setCustomDate} >بازه دلخواه</Button>
                            </div>
                        </div>
                        <div className={customDateClass}>
                            <div className="row w-100 pr-4 mt-4">
                                <div className="col-6 small-col-date-picker">
                                    <DatePicker placeHolder="از تاریخ" value={fromDate} change={changeFromDate} />
                                </div>
                                <div className="col-6 small-col-date-picker">
                                    <DatePicker placeHolder="تا تاریخ" value={toDate} change={changeToDate} />
                                </div>
                            </div>
                        </div>
                    </div>
            
                </div>
                <div className="row text-right pl-4 pr-4">
                    <div className="col-1"></div>
                    <div className="col-3 small-main-dates pt-3">
                        <div className="MainCounter">
                            <div className="third-header">
                                سفارشات جاری
                            </div>
                            <div className="MainContent">
                                <CirclePercentage
                                    total={totalCount}
                                    count={ongoingCount}
                                    progress={ongoingCount * 100 / totalCount}
                                    size={150}
                                    strokeWidth={15}
                                    circleOneStroke='#111183'
                                    circleTwoStroke='#111183'
                                    textClass="third"
                                    clicked={getFromOfficeOrders}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className="col-3 small-main-dates pt-3">
                        <div className="MainCounter">
                            <div className="body-header">
                                سفارشات نهایی
                            </div>
                            <div className="MainContent">
                                <CirclePercentage
                                    total={totalCount}
                                    count={finishedCount}
                                    progress={finishedCount * 100 / totalCount}
                                    size={150}
                                    strokeWidth={15}
                                    circleOneStroke='#111183'
                                    circleTwoStroke='#111183'
                                    textClass="body"
                                    clicked={getToOfficeOrders}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
                {hasError == true ?
                            <div class="row justify-content-center mt-5">
                                <div>
                                    <Alert variant="error" class="mt-3" text={errorContent} />
                                </div>
                            </div>
                            : ''}
            </div>
            )
}
export default MainContent